var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"editorContainer",class:[
    'table-editor-container',
    {
      'no-border': _vm.borderColor === _vm.EColors.Transparent,
      'alternate-row-color': _vm.alternateRowColor === _vm.EColors.Gray,
      'header-row-background-color': _vm.headerRowBackgroundColor === _vm.EColors.Gray,
      overflow: _vm.overflow,
    } ]},[_c('EditorContent',{attrs:{"editor":_vm.viewer,"spellcheck":"false"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }